import { defineComponent, h } from "vue";
import { call } from "@varlet/shared";
import { createNamespace } from "../utils/components.mjs";
import { formatStyleVars } from "../utils/elements.mjs";
import { props } from "./props.mjs";
const { name, n } = createNamespace("style-provider");
const __sfc__ = defineComponent({
  name,
  props,
  setup(props2, { slots }) {
    return () => h(
      props2.tag,
      {
        class: n(),
        style: formatStyleVars(props2.styleVars)
      },
      call(slots.default)
    );
  }
});
var stdin_default = __sfc__;
export {
  stdin_default as default
};
